module.exports = __webpack_public_path__ + "static/media/Artboard6.5c8fe5a5.png";